const DE_DATE: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };

export function formatDateDe(date: string | number | Date): string {
  return new Date(date).toLocaleDateString('de-DE', DE_DATE);
}

export function formatWeekdayDateTimeUtcDe(date: string | number | Date): string {
  return new Date(date).toLocaleString('de-DE', {
    weekday: 'long',
    ...DE_DATE,
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
  });
}

export function formatTimeUtcDe(date: string | number | Date): string {
  return new Date(date).toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
  });
}

export function isSameDay(a: string | number | Date, b: string | number | Date): boolean {
  const da = new Date(a);
  const db = new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
}
